import { _normalizeColorValue } from '../core/utilities.js';

export function initColorPickers() {
    var $colorPickers = $('.colorpicker-component');

    if (!$colorPickers.length) {
        return;
    }

    $colorPickers.each(function () {
        var $picker = $(this);
        var $textInput = $picker.find('input[type="text"]');
        var $swatch = $picker.find('.input-group-text i');
        var colorValue = _normalizeColorValue($textInput.val()) || '#000000';

        if (!$textInput.length) {
            return;
        }

        var $nativePicker = $picker.find('input[type="color"]');
        if (!$nativePicker.length) {
            $nativePicker = $(
                '<input type="color" class="d-none" style="position: absolute; opacity: 0; pointer-events: none;" />'
            ).appendTo($picker);
        }

        $textInput.val(colorValue);
        $picker.css('position', 'relative');
        $nativePicker.val(colorValue);

        updateColorSwatch($swatch, colorValue);

        $picker.find('.input-group-text').css('cursor', 'pointer');
        $picker
            .find('.input-group-text')
            .off('click.colorpicker')
            .on('click.colorpicker', function () {
                $nativePicker[0].click();
            });

        $nativePicker
            .off('input.colorpicker change.colorpicker')
            .on('input.colorpicker change.colorpicker', function () {
                var color = _normalizeColorValue($(this).val());

                if (!color) {
                    color = '#000000';
                }

                $textInput.val(color);
                updateColorSwatch($swatch, color);
            });

        $textInput
            .off('input.colorpicker change.colorpicker')
            .on('input.colorpicker change.colorpicker', function () {
                var color = _normalizeColorValue($textInput.val());

                if (!color) {
                    return;
                }

                $nativePicker.val(color);
                updateColorSwatch($swatch, color);
            });
    });

    function updateColorSwatch($icon, color) {
        $icon.css({
            'background-color': color,
            display: 'inline-block',
            width: '16px',
            height: '16px',
            border: '1px solid #ccc',
            'border-radius': '2px',
        });
    }
}
